import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  Grid,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const useStyles = makeStyles((theme) => ({
  headerBox: {
    background: "#c1d0ed",
  },
  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "rgb(29, 66, 138)",
  },
  tableRow: {
    padding: "0px !important",
    "&:nth-child(odd)": {
      background: "#f5f5f5",
    },
    "& .MuiTableCell-root": {
      borderBottom: "none",
      padding: theme.spacing(0.5), // Reduced padding between rows
    },
  },
  headerTableRow: {
    padding: "0px !important",
    "& .MuiTableCell-root": {
      borderBottom: "none",
      padding: theme.spacing(0.5), // Reduced padding between rows
    },
  },
}));

const TableWithPagination = ({
  title,
  columns,
  rows,
  rowsPerPage,
  page,
  handlePageChange,
  handleRowsPerPageChange,
  handleEdit,
  handleDelete,
}) => {
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      style={{ padding: "10px 24px" }}
    >
      <Grid item xs={12}>
        <Paper elevation={3}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                {title}
              </Typography>
            </Box>
          </Box>
          <Box p={2}>
            <TableContainer>
              <Table aria-label="dynamic-table">
                <TableHead>
                  <TableRow className={classes.headerTableRow}>
                    {columns.map((col, index) => (
                      <TableCell key={index} align={col.align || "left"}>
                        {col.label}
                      </TableCell>
                    ))}
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        {columns.map((col, colIndex) => (
                          <TableCell key={colIndex} align={col.align || "left"}>
                            {row[col.field]}
                          </TableCell>
                        ))}
                        <TableCell align="center">
                          <IconButton
                            color="primary"
                            onClick={() => handleEdit(row)}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => handleDelete(row)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            </TableContainer>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TableWithPagination;
